import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TIMEOUTS } from '../config/timeouts';
import { useAuth } from '../contexts/AuthContext';
import LogoutButton from './LogoutButton';

import { FiPhoneCall } from 'react-icons/fi';

// Import images
import adalogo from '../assets/images/adalogo.png';
import pmedia from '../assets/images/polarismedia_logo_neg.svg';

function formatRemainingTotalSeconds(totalSec) {
	if (totalSec <= 0) {
		return 'Sesjon utløper …';
	}
	if (totalSec >= 3600) {
		const h = Math.floor(totalSec / 3600);
		const m = Math.floor((totalSec % 3600) / 60);
		const s = totalSec % 60;
		return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
	}
	const m = Math.floor(totalSec / 60);
	const s = totalSec % 60;
	return `${m}:${String(s).padStart(2, '0')}`;
}

function formatSessionRemaining(expiresAtIso) {
	const expMs = new Date(expiresAtIso).getTime();
	if (!Number.isFinite(expMs)) {
		return '';
	}
	const ms = expMs - Date.now();
	if (ms <= 0) {
		return 'Sesjon utløper …';
	}
	const totalSec = Math.floor(ms / 1000);
	return formatRemainingTotalSeconds(totalSec);
}

const Header = () => {
	const {
		isLoggedIn,
		userRole,
		devMailMode,
		setDevMailMode,
		sessionIdleExpiresAt,
		sessionIdleRemainingSeconds,
		sessionIdleSyncedAtClientMs,
	} = useAuth();
	const [sessionRemaining, setSessionRemaining] = useState('');

	useEffect(() => {
		if (!isLoggedIn) {
			setSessionRemaining('');
			return;
		}
		const tick = () => {
			if (
				sessionIdleSyncedAtClientMs != null &&
				typeof sessionIdleRemainingSeconds === 'number'
			) {
				const elapsedSec = Math.floor(
					(Date.now() - sessionIdleSyncedAtClientMs) / 1000
				);
				const rem = Math.max(0, sessionIdleRemainingSeconds - elapsedSec);
				setSessionRemaining(formatRemainingTotalSeconds(rem));
				return;
			}
			if (sessionIdleExpiresAt) {
				setSessionRemaining(formatSessionRemaining(sessionIdleExpiresAt));
			} else {
				setSessionRemaining('');
			}
		};
		tick();
		const id = setInterval(tick, TIMEOUTS.headerSessionTickMs);
		return () => clearInterval(id);
	}, [
		isLoggedIn,
		sessionIdleExpiresAt,
		sessionIdleRemainingSeconds,
		sessionIdleSyncedAtClientMs,
	]);

	return (
		<div className='main-header'>
			{userRole === 'superAdmin' ? (
				<div className='main-header__devmail'>
					<button
						type='button'
						className={`dev-mail-toggle ${devMailMode ? 'active' : ''}`}
						onClick={() => setDevMailMode((prev) => !prev)}
					>
						Dev-mail: {devMailMode ? 'PÅ' : 'AV'}
					</button>
				</div>
			) : null}
			{isLoggedIn && sessionRemaining ? (
				<div
					className='main-header__session'
					aria-live='polite'
					title='Gjenstående tid før automatisk utlogging ved langvarig inaktivitet'
				>
					<span className='session-indicator__label'>Sesjon</span>
					<span className='session-indicator__time'>{sessionRemaining}</span>
				</div>
			) : null}
			<div className='header-content'>
				<div className='ada-logo'>
					<img src={adalogo} alt='' />
				</div>
				<nav className='header-nav' aria-label='Hovedmeny'>
					<ul>
						<li>
							<Link to='/'>Skjema</Link>
						</li>
						{isLoggedIn ? (
							<>
								<li>
									<Link to='/statistikk'>Statistikk</Link>
								</li>
								<li>
									<Link to='/orders'>Ordrer</Link>
								</li>
								<li>
									<Link to='/profile'>Profil</Link>
								</li>
								<li>
									<LogoutButton />
								</li>
							</>
						) : (
							<li>
								<Link to='/login'>Logg inn</Link>
							</li>
						)}
					</ul>
				</nav>
				<div className='alogo-section'>
					<div className='contact'>
						<h2>Kenneth Aalbu</h2>
						<div>
							<FiPhoneCall size='16' />{' '}
							<a href='tel:92028031'>920 28 031</a>
						</div>
					</div>
					<div className='border'></div>
					<img src={pmedia} alt='pmedia' />
				</div>
			</div>
		</div>
	);
};

export default Header;
